module.exports = __webpack_public_path__ + "static/img/topbg1.c5bcbbc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productConter/topbg1.png
// module id = ZU2U
// module chunks = 1